import React from 'react';

const EMOJI_CATEGORIES = {
  'Smileys': ['😀', '😊', '🙂', '😄', '😅', '😂', '🤣', '😇', '😉', '😍'],
  'Gesten': ['👍', '👎', '👌', '👏', '🙌', '👋', '✌️', '🤘', '👊', '💪'],
  'Herzen': ['❤️', '💜', '💙', '💚', '💛', '🧡', '🖤', '💝', '💖', '💗'],
  'Musik': ['🎵', '🎶', '🎼', '🎸', '🎹', '🎺', '🎷', '🥁', '🎤', '🎧'],
};

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
}

export function EmojiPicker({ onSelect }: EmojiPickerProps) {
  const [activeCategory, setActiveCategory] = React.useState<keyof typeof EMOJI_CATEGORIES>('Smileys');

  return (
    <div className="bg-background-secondary border border-divider rounded-lg shadow-lg w-64">
      {/* Categories */}
      <div className="flex border-b border-divider">
        {Object.keys(EMOJI_CATEGORIES).map((category) => (
          <button
            key={category}
            onClick={() => setActiveCategory(category as keyof typeof EMOJI_CATEGORIES)}
            className={`flex-1 p-2 text-sm hover:bg-background-tertiary transition-colors ${
              activeCategory === category ? 'text-accent-primary' : 'text-text-secondary'
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Emojis */}
      <div className="p-2 grid grid-cols-5 gap-1">
        {EMOJI_CATEGORIES[activeCategory].map((emoji) => (
          <button
            key={emoji}
            onClick={() => onSelect(emoji)}
            className="p-2 hover:bg-background-tertiary rounded transition-colors text-lg"
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
}